import en from './en/translation.json';
import ar from './ar/translation.json';
import ur from './ur/translation.json';

export default {
  en: { translation: en },
  ar: { translation: ar },
  ur: { translation: ur },
};
